import React from 'react';
import ConfirmationModal from '@lsq/nextgen/v2/modal/confirmation-modal';
import { casaConstants } from '../../constants/globalConstant';

const noopEvent = { stopPropagation: () => {}, preventDefault: () => {} };

export default function ConfirmDialog({
  setState,
  illustration,
  title = '',
  displayText,
  buttonLabel = 'Delete',
  clickListener,
  isConfirmLoading = false
}) {
  const handleCancel = () => setState?.({ state: false });
  const handleConfirm = () => clickListener?.(noopEvent);

  return (
    <ConfirmationModal
      customStyleClass="m-auto"
      show
      icon={illustration}
      title={title}
      description={displayText}
      buttonConfig={[
        {
          id: 1,
          name: casaConstants.CANCEL,
          variant: 'secondary',
          size: 'sm',
          onClick: handleCancel,
          dataTestId: 'cancel-btn',
          isDisabled: isConfirmLoading
        },
        {
          id: 2,
          name: buttonLabel,
          variant: 'primary',
          size: 'sm',
          onClick: handleConfirm,
          dataTestId: 'confirm-btn',
          isLoading: isConfirmLoading,
          isDisabled: isConfirmLoading
        }
      ]}
    />
  );
}
